import { render, staticRenderFns } from "./dutyManagement.vue?vue&type=template&id=0f72bc14&scoped=true"
import script from "./dutyManagement.vue?vue&type=script&lang=js"
export * from "./dutyManagement.vue?vue&type=script&lang=js"
import style0 from "./dutyManagement.vue?vue&type=style&index=0&id=0f72bc14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f72bc14",
  null
  
)

export default component.exports